
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/coaching/start",
      function () {
        return require("private-next-pages/coaching/start.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/coaching/start"])
      });
    }
  